import { paymentClient } from "@core/clients";
import { Payments, SbpPaymentArgs } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

type Options = UseMutationOptions<Payments | null, any, SbpPaymentArgs>;

export function useSbpPaymentMutation(options?: Options) {
  return useMutation<Payments | null, any, SbpPaymentArgs>({
    mutationKey: ["payment", "sbp"],
    mutationFn: (args) => paymentClient.createSBPPayment(args),
    ...options,
  });
}
